<template>
  <div class="mt-3">
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ $t('formError.unknownwError') }}
    </b-alert>
    <div v-if="buttonArt === 'default'">
      <b-button variant="primary" v-if="show === true" disabled class="custom-button">
        <b-spinner small></b-spinner>
        Datei wird generiert
      </b-button>
      <b-button variant="primary" v-else @click="getFile"  class="custom-button">Unterschriftenformular herunterladen</b-button>
    </div>
    <div v-if="buttonArt === 'detail'">
      <b-button class="btn btn-green custom-button" v-if="show === true" disabled>
        <b-spinner small></b-spinner>
        Datei wird generiert
      </b-button>
      <b-button class="btn btn-green custom-button" v-else @click="getFile">Gesuch ausdrucken</b-button>
    </div>
    <div v-if="buttonArt === 'digitaldetail'">
      <p v-if="show === true"><b-spinner small></b-spinner> Datei wird geladen</p>
      <p v-else><a href="javascript:void(0)" @click="getFile" class="download-file"><file-icon class="icon-gray" :size="18"/> Gesuch_{{gesuchArt}}{{applicationId}}.pdf <download-icon class="ml-2" :size="22"/></a></p>
    </div>
  </div>
</template>

<script>
  import { errorHandler } from '@/helpers/formHelper.js'
  import FileIcon from 'vue-material-design-icons/FileOutline.vue'
  import DownloadIcon from 'vue-material-design-icons/TrayArrowDown.vue'

  export default {
    data: () => ({
      hasUnknownError: false,
      show: false
    }),
    components: {
      FileIcon,
      DownloadIcon
    },
    created () {
      this.setTimeoutSpinner()
      this.show = this.showSpinner
    },
    methods: {
      async getFile () {
        const applicationId = this.applicationId
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('file/GET_FILE_DOWNLOAD', {
          gesuchId: applicationId
        }).then(async res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const { fileContentBase64, fileName } = data.gesuchUnterschriftblattFile

          if (!fileContentBase64 || !fileName) {
            this.hasUnknownError = true
            return
          }

          const base64 = 'data:application/pdf;base64,' + fileContentBase64
          const blob = await (await fetch(base64)).blob()
          const objectURL = URL.createObjectURL(blob)

          const a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          a.href = objectURL
          a.download = fileName
          a.click()
          URL.revokeObjectURL(objectURL)
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      },
      setTimeoutSpinner () {
        setTimeout(() => {
          this.show = false
        }, 5000)
      }
    },
    props: {
      applicationId: {
        type: Number,
        required: true
      },
      showSpinner: {
        type: Boolean
      },
      buttonArt: {
        type: String
      },
      gesuchArt: {
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>
.custom-button{
  font-size: 14px !important;
}

.icon-gray {
  background-color: $black-10;
  padding: 3px .5rem .5rem;
  border-radius: 0.5rem;
  margin-right: 0.25rem;
}

.download-file {
  cursor: pointer;
  text-decoration: none;
}

</style>
